import React from 'react';
import I18n from 'i18n-js';
import { SectionType } from '@/types/api/LessonOverview';
import useLessonOverviewContext from '@/components/shared/NewLessonOverview/useLessonOverviewContext';
import { readingPath } from '@/components/shared/LessonOverview/utils';
import readingIcon from 'images/icons/reading-white.svg';
import Card, { CardBody } from './Card';
import ActionBar from './ActionBar';

type ReadingCardProps = {
  iconColor: string;
  sections: SectionType[];
  truncateTextTooltip?: boolean;
};

const ReadingCard = ({ iconColor, sections, truncateTextTooltip = false } : ReadingCardProps) => {
  const program = useLessonOverviewContext(state => state.program);
  const showThumbnail = !!program.readingCardImageUrl;

  return (
    <div className={showThumbnail ? 'tw-row-span-2' : undefined}>
      <Card type="reading">
        <CardBody
          ariaLabel="reading"
          iconColor={iconColor}
          iconSrc={readingIcon}
          linkHref={readingPath(null, program, sections)}
          linkLabel={I18n.t('reading')}
          page={sections[0].startPage}
          showThumbnail={showThumbnail}
          thumbnail={program.readingCardImageUrl}
          truncateTextTooltip={truncateTextTooltip}
        />
        <ActionBar
          href={readingPath(null, program, sections)}
          iconType="arrow"
          initialValues={{
            modelType: 'sectionNotebook',
            modelsToAssign: sections.map(section => section.assignable.value),
          }}
          isAssigned={sections.some(section => section.isAssigned)}
        />
      </Card>
    </div>
  );
};

export default ReadingCard;
